import { useDispatch } from "react-redux";
import { TasksGrid } from "../tasks/TasksGrid";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { setPageTitle } from "../../store/slices/pageTitleSlice";

export const Task = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const dispatch = useDispatch();
  useEffect(() => {
      dispatch(setPageTitle('Tasks: Patient Profile | Spire360'));
  }, []);
  
  return <TasksGrid patientId={patientId} />
};
